import { WEB_PURPLE_REG, WEB_WHITE_REG } from '@mnd-frontend/ui/shared/tokens';
import type { TextColorDataType } from '../../types/color';

export const getTextColor = (colorData: TextColorDataType | string) =>
  colorData === 'deep-purple' ? WEB_PURPLE_REG : WEB_WHITE_REG;
